var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-filter',{attrs:{"load-json":true,"model":_vm.useModel,"developer":false,"program-value":_vm.formValues.programId,"include-value":true,"startdate":_vm.formValues.startdate,"enddate":_vm.formValues.enddate,"extra-parameters":{ type: 'class' }},on:{"filteredEvents":_vm.storeEventsInStore,"queryUpdated":_vm.queryUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }